import React from 'react';
import { Link } from 'react-router-dom';
import { FooterArea } from './styled';
import { WHATSAPP_URL } from '../../WhatsAppButton';

const features = [
    { title: 'Feitos com carinho', text: 'e ingredientes selecionados' },
    { title: 'Qualidade', text: 'que seu cliente prova e aprova' },
    { title: 'Parceria de confiança', text: 'que gera resultados' },
];

const Footer = () => {
    return (
        <FooterArea>
            <div className="container">
                <div className="footerTop">
                    {features.map((f) => (
                        <div className="featureItem" key={f.title}>
                            <span className="featureDot" aria-hidden="true"></span>
                            <div>
                                <strong>{f.title}</strong>
                                <span>{f.text}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="footerMain">
                    <div className="footerBrand">
                        <img src={require('../../../assets/images/logo-salato.png')} alt="Salato Alimentos" width="517" height="269" loading="lazy" />
                        <p>Salgados congelados com qualidade, sabor e tradição para o seu negócio.</p>
                    </div>

                    <nav className="footerCol" aria-label="Rodapé">
                        <strong>Navegação</strong>
                        <Link to="/">Home</Link>
                        <Link to="/produtos">Produtos</Link>
                        <Link to="/historia">Quem Somos</Link>
                        <Link to="/contato">Contato</Link>
                    </nav>

                    <div className="footerCol">
                        <strong>Atendimento</strong>
                        <a href={WHATSAPP_URL} target="_blank" rel="noreferrer">WhatsApp (21) 98485-6295</a>
                        <a href="mailto:comercial@salato.com.br">comercial@salato.com.br</a>
                        <a href="https://www.instagram.com/salato_alimentos/" target="_blank" rel="noreferrer">Instagram</a>
                        <a href="https://www.facebook.com/salatoalimentos" target="_blank" rel="noreferrer">Facebook</a>
                    </div>

                    <div className="footerCol">
                        <strong>Fábrica</strong>
                        <span>Rua Waldemar Colombo Garcia, 491</span>
                        <span>Condomínio Unidas · Magé/RJ</span>
                    </div>
                </div>

                <div className="footerBottom">
                    <p>© {new Date().getFullYear()} Salato Alimentos LTDA. Todos os direitos reservados.</p>
                </div>
            </div>
        </FooterArea>
    );
};

export default Footer;
